import { createClient } from '@supabase/supabase-js';
import type { SupabaseClient } from '@supabase/supabase-js';

let realtimeClient: SupabaseClient | null = null;
let loggedMissingConfig = false;

/**
 * Returns a singleton Supabase client for Realtime subscriptions.
 * Falls back to null when env vars are missing.
 */
export function getSupabaseRealtimeClient(): SupabaseClient | null {
  if (realtimeClient) {
    return realtimeClient;
  }

  const useDevDb = process.env.DEV_DATABASE === 'true';
  const supabaseUrl = useDevDb
    ? process.env.REACT_APP_SUPABASE_DEV_URL || ''
    : process.env.REACT_APP_SUPABASE_URL || process.env.REACT_APP_SUPABASE_ERP_URL || '';
  const supabaseAnonKey = useDevDb
    ? process.env.REACT_APP_SUPABASE_DEV_ANON_KEY || ''
    : process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ERP_ANON_KEY || '';

  if (!supabaseUrl || !supabaseAnonKey) {
    if (!loggedMissingConfig) {
      loggedMissingConfig = true;
      console.warn(
        '[realtime] Supabase Realtime disabled: missing REACT_APP_SUPABASE_URL/ANON_KEY'
      );
    }
    return null;
  }

  realtimeClient = createClient(supabaseUrl, supabaseAnonKey, {
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
  });

  return realtimeClient;
}
